/**
 * ReportsHarvestInspectionPickerFaultPercentage
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectReportsHarvestInspectionValue } from '../../services/reportsHarvestInspections/selectors';

interface Props {
    pickerFaultPercentage?: ?number;
}

export class ReportsHarvestInspectionPickerFaultPercentage extends React.PureComponent<Props> {
    render() {
        const { pickerFaultPercentage } = this.props;
        if (!pickerFaultPercentage && pickerFaultPercentage !== 0) return null;
        return `${pickerFaultPercentage}%`;
    }
}

const mapStateToProps = createStructuredSelector({
    pickerFaultPercentage: makeSelectReportsHarvestInspectionValue(
        'pickerFaultPercentage'
    )
});

export default connect(mapStateToProps)(
    ReportsHarvestInspectionPickerFaultPercentage
);
